var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinus3({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 9.78906C2.5 9.44388 2.77982 9.16406 3.125 9.16406H16.4583C16.8035 9.16406 17.0833 9.44388 17.0833 9.78906C17.0833 10.1342 16.8035 10.4141 16.4583 10.4141H3.125C2.77982 10.4141 2.5 10.1342 2.5 9.78906Z",
    fill: "#D53E20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinus3);
export default __webpack_public_path__ + "static/media/minus-3.cb7d842c2f8edbd2cb2ed4f089cb50ac.svg";
export { ForwardRef as ReactComponent };